import { render, staticRenderFns } from "./nameApps.template.vue?vue&type=template&id=6b79fc3a&scoped=true&"
var script = {}
import style0 from "./nameApps.template.vue?vue&type=style&index=0&id=6b79fc3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b79fc3a",
  null
  
)

export default component.exports